// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3Jf8p","checkboxCol":"Table_checkboxCol__3li9V","emailCol":"Table_emailCol__ok89j","actionCol":"Table_actionCol__TtgYu"};